var map = {
	"./slide_billma.png": "./src/assets/images/carrousel/slide_billma.png",
	"./slide_gag.png": "./src/assets/images/carrousel/slide_gag.png",
	"./slide_ren.png": "./src/assets/images/carrousel/slide_ren.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/carrousel sync recursive ^\\.\\/.*\\.png$";